module.exports = __webpack_public_path__ + "static/media/laptop_on_table.a1f31fae.jpg";